/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdminTicketScans,
  DecryptedTicketScan,
  ErrorResponse,
  PlayerTicketScans,
  TicketScanRequest,
} from '../models/index';
import {
    AdminTicketScansFromJSON,
    AdminTicketScansToJSON,
    DecryptedTicketScanFromJSON,
    DecryptedTicketScanToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    PlayerTicketScansFromJSON,
    PlayerTicketScansToJSON,
    TicketScanRequestFromJSON,
    TicketScanRequestToJSON,
} from '../models/index';

export interface GetDecryptedTicketScanRequest {
    scanId: string;
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetTicketScansForBarcodeRequest {
    customerId: string;
    ticketScanRequest: TicketScanRequest;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetTicketScansForPlayerRequest {
    playerLookupId: string;
    customerId: string;
    resultStart: number;
    resultEnd: number;
    date?: Date;
    xClientID?: string;
    xRequestID?: string;
}

/**
 * 
 */
export class TicketScansApi extends runtime.BaseAPI {

    /**
     * Get decrypted ticket scan by ID
     */
    async getDecryptedTicketScanRaw(requestParameters: GetDecryptedTicketScanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DecryptedTicketScan>> {
        if (requestParameters['scanId'] == null) {
            throw new runtime.RequiredError(
                'scanId',
                'Required parameter "scanId" was null or undefined when calling getDecryptedTicketScan().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getDecryptedTicketScan().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:barcodes"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/ticket-scans/decrypted/{scanId}`;
        urlPath = urlPath.replace(`{${"scanId"}}`, encodeURIComponent(String(requestParameters['scanId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DecryptedTicketScanFromJSON(jsonValue));
    }

    /**
     * Get decrypted ticket scan by ID
     */
    async getDecryptedTicketScan(requestParameters: GetDecryptedTicketScanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DecryptedTicketScan> {
        const response = await this.getDecryptedTicketScanRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get ticket scans for a specific barcode
     */
    async getTicketScansForBarcodeRaw(requestParameters: GetTicketScansForBarcodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminTicketScans>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getTicketScansForBarcode().'
            );
        }

        if (requestParameters['ticketScanRequest'] == null) {
            throw new runtime.RequiredError(
                'ticketScanRequest',
                'Required parameter "ticketScanRequest" was null or undefined when calling getTicketScansForBarcode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:player-scans"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/ticket-scans/find-by-barcode`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TicketScanRequestToJSON(requestParameters['ticketScanRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminTicketScansFromJSON(jsonValue));
    }

    /**
     * Get ticket scans for a specific barcode
     */
    async getTicketScansForBarcode(requestParameters: GetTicketScansForBarcodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminTicketScans> {
        const response = await this.getTicketScansForBarcodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get ticket scans for a player by lookup ID. Results can be paginated using resultStart and resultEnd
     */
    async getTicketScansForPlayerRaw(requestParameters: GetTicketScansForPlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlayerTicketScans>> {
        if (requestParameters['playerLookupId'] == null) {
            throw new runtime.RequiredError(
                'playerLookupId',
                'Required parameter "playerLookupId" was null or undefined when calling getTicketScansForPlayer().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getTicketScansForPlayer().'
            );
        }

        if (requestParameters['resultStart'] == null) {
            throw new runtime.RequiredError(
                'resultStart',
                'Required parameter "resultStart" was null or undefined when calling getTicketScansForPlayer().'
            );
        }

        if (requestParameters['resultEnd'] == null) {
            throw new runtime.RequiredError(
                'resultEnd',
                'Required parameter "resultEnd" was null or undefined when calling getTicketScansForPlayer().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['resultStart'] != null) {
            queryParameters['resultStart'] = requestParameters['resultStart'];
        }

        if (requestParameters['resultEnd'] != null) {
            queryParameters['resultEnd'] = requestParameters['resultEnd'];
        }

        if (requestParameters['date'] != null) {
            queryParameters['date'] = (requestParameters['date'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:player-scans"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/ticket-scans/player/{playerLookupId}`;
        urlPath = urlPath.replace(`{${"playerLookupId"}}`, encodeURIComponent(String(requestParameters['playerLookupId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlayerTicketScansFromJSON(jsonValue));
    }

    /**
     * Get ticket scans for a player by lookup ID. Results can be paginated using resultStart and resultEnd
     */
    async getTicketScansForPlayer(requestParameters: GetTicketScansForPlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlayerTicketScans> {
        const response = await this.getTicketScansForPlayerRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
